<template>
  <div>
    <w-sliding-popup ref="slidingPopup" :title="`${popupParams.objName} 정책감사 수행결과`" width="700px" @close="close">
      <div slot="content">
        <el-table-wrapper style="width:100%;" ref="resultTable" :data="policyExecuteResultList" :columns="tableColumns" :total="total" :column-default="columnDefault" :pagination="true" remote
          :show-custom-header="true" :show-search-tool="false" @condition-change="loadData">
          <template slot-scope="scope" slot="severity-slot">
            <span :class="`severity-${scope.row.severityId.toLowerCase()}`">{{ scope.row.severityName }}</span>
          </template>
          <template slot-scope="scope" slot="script-slot">
            <i class="fas fa-play-circle c-pointer" @click="executeScript(scope.row)"></i>
          </template>
        </el-table-wrapper>
      </div>

    </w-sliding-popup>
    <w-execute-rule-script-popup :popup-params="scriptPopupParams" ref="executeRuleScriptPopup" @open="close" @close="open"></w-execute-rule-script-popup>
  </div>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WExecuteRuleScriptPopup from './ExecuteRuleScriptPopup';

export default {
  name: 'WPolicyExecuteResultPopup',
  components: { WExecuteRuleScriptPopup },
  props: {
    popupParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      popupVisible: false,
      scriptPopupParams: {},
      policyExecuteResultList: [],
      total: 0,
      columnDefault,
      tableColumns: [
        { prop: 'severityName', label: '등급', scopedSlot: 'severity-slot', remoteProp: 'ncrs.severity_name', width: 70, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ruleId', label: '룰 ID', remoteProp: 'ncs.rule_id', width: 70, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ruleName', label: '룰 이름', remoteProp: 'ncr.rule_name', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'templateName', label: '권장스크립트', remoteProp: 'nct.template_name', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '스크립트 실행', scopedSlot: 'script-slot', width: 120, align: 'center', headerAlign: 'center', sortable: true, searchable: false },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 정책감사 수행결과 데이터 로드
     * @author jeee12
     */
    loadData() {
      const tableParams = this.$refs.resultTable.getParameter();
      const params = {
        objId: this.popupParams.objId,
        policyId: this.popupParams.policyId,
        severityId: this.popupParams.severityId,
        ...tableParams,
      };

      netdeviceInfoAPI.getNetdevicePolicyExecuteResultList(params).then((response) => {
        if (response.data.success) {
          this.policyExecuteResultList = response.data.data;
          this.total = response.data.total;
        } else {
          this.policyExecuteResultList = [];
          this.total = 0;
        }
      });
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 스크립트 실행 click
     * @author jeee12
     * @param  {[type]} row 해당 row
     */
    executeScript(row) {
      if (row.templateName) {
        this.scriptPopupParams = row;
        this.$refs.executeRuleScriptPopup.open();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/PolicyExecuteResultPopup.vue